// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const DotsCircleHorizontalIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "DotsCircleHorizontal/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
}));
export default DotsCircleHorizontalIcon;